<header class="header">
  <img
    src="/assets/lasuite/images/logo.svg"
    alt="うめきた温泉蓮"
    width="40"
    height="16"
  />
  <p class="text-h5">&ensp;新規会員登録</p>
</header>
<div class="container">
  <div class="auto-layout">
    <app-lasuite-oem-register-message
      [clientId]="clientId"
      *ngIf="isOem; else isStation"
    ></app-lasuite-oem-register-message>
    <ng-template #isStation>
      <p class="v-text">
        ご登録完了後、ご入力いただいたメールアドレス宛に<br
          class="br-pc"
        />登録の確認メールをお送りします。
      </p>
    </ng-template>
  </div>
  <div data-app="true" class="v-application v-application--is-ltr theme--light">
    <div class="v-application--wrap">
      <div class="inner">
        <!-- リンクが花粉症のページになっている（コピペ時の削除漏れ.
        ラスイート向けにページ新設してリンク配置するかもしれないので、一旦コメントアウトで隠す -->
        <!-- <div
          style="display: flex; justify-content: center; align-items: baseline"
        >
          <div class="text-center mb-6 v-text-caption">
            よくあるご質問はこちら
          </div>
          <a
            class="text-link v-text-caption"
            href="https://kafunsho-doctor.doctors-station.com/#faq"
            >こちら</a
          >
        </div> -->

        <app-register-form
          [dates]="masterData.dates"
          [months]="masterData.month"
          [years]="masterData.years.slice().reverse()"
          [termsUrl]="termsUrl"
          (register)="onSubmit($event)"
          [errorsFromResponse]="errorMessages.signup"
        ></app-register-form>

        <app-register-resend
          (navigate)="navigate('register-resend')"
        ></app-register-resend>

        <div class="divider mb-3"></div>

        <app-register-login (navigate)="navigate('login')"></app-register-login>
      </div>
    </div>
  </div>
</div>
